import type { DogBreederWhereInput } from '@gql/graphql';
import type { LitterListPageFormValues } from '@presentation/pages';
import { useCallback } from 'react';

export const useBreederWhereBuilder = () => {
  const breederWhereBuilder = useCallback(
    (form: LitterListPageFormValues): DogBreederWhereInput => {
      const whereInputs: DogBreederWhereInput[] = [];

      whereInputs.push({
        certified: { equals: true },
      });

      whereInputs.push({
        public: { equals: true },
      });

      whereInputs.push({
        breederBreeds: {
          some: {
            dogBreed: {
              is: {
                OR: [{ name: { in: form.breedNames } }, { baseBreedName: { in: form.breedNames } }],
              },
            },
          },
        },
      });

      return { ...(whereInputs.length ? { AND: whereInputs } : {}) } as DogBreederWhereInput;
    },
    [],
  );

  return { breederWhereBuilder };
};
